import i18next from "i18next"

const dountChartOptions = {
  cutout: "80%",
  plugins: {
    legend: {
      onClick: null,
      position: "bottom",
      labels: {
        usePointStyle: true,
        boxWidth: 10,
        boxHeight: 10,
        padding: 5,
        font: { size: 12 },
        generateLabels: chart => {
          const { data } = chart
          return data.labels.map((label, i) => ({
            text: `${label} ${data.datasets[0].data[i].toLocaleString()}`, // Adds commas
            fillStyle: data.datasets[0].backgroundColor[i],
            hidden: false,
            index: i,
            strokeStyle: data.datasets[0].backgroundColor[i],
            pointStyle: "rect",
          }))
        },
      },
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          const dataset = tooltipItem.dataset.data
          const total = dataset.reduce((acc, num) => acc + num, 0)
          const value = dataset[tooltipItem.dataIndex]
          const percentage = ((value / total) * 100).toFixed(1)

          return [
            `${i18next.t("Total Count")}: ${value.toLocaleString()}`,
            `${i18next.t("Percentage")}: ${percentage}%`,
          ]
        },
      },
    },
    datalabels: {
      display: false,
    },
  },
}

const hasValidChartData = chartData => {
  if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
    return false
  }

  return chartData.datasets[0].data.some(count => count > 0)
}

export { dountChartOptions, hasValidChartData }
